import { useState, useEffect, useRef } from 'react';
import { ActionButton } from '../../common/Buttons/Buttons';
import { Header } from '../../common/Header/Header.jsx';
import { SelectPerPage } from '../../common/Forms/Input/Input';
import { RenewalMembershipTable } from '../../common/Tables/Tables';
import { renewalTableHeader } from '../../../assets/helpers/tables';
import { notify } from '../../../assets/helpers/toast';
import { membershipService } from '../../../services/membershipService';
import { membershipCatalogService } from '../../../services/membershipCatalogService';
import { giftCardService } from '../../../services/giftCardService';
import { productService } from '../../../services/productService';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';
import * as schemas from '../../../assets/schemas/schemas';
import { useParams, useHistory } from 'react-router-dom';
import { Input, SearchInputWithSelector } from '../../common/Forms/Input/Input';
import { RenewalExportTypeBreadcrumb } from '../../common/Dropzone/Dropzone';
import moment from 'moment';
import {
  planStatus,
  monthsOptions,
  LANDING,
  codeTypeEnum,
  codeTypeOptions,
  validateCodeEnum,
  getKmServiceOptions,
  getDefaultPlanKm,
  ExportableOtpModules,
  vehicleUsageOptions,
  vehiclesEnum,
  vehicleUsageEnum,
  rcvEnum,
  membershipSituationOptions,
} from '../../../assets/helpers/options';
import './AffiliationsDB.scss';
import {
  capitalize,
  filterParams,
  removeBlankSpacesAndUppercase,
  clearObject,
  filterById,
  filterRCVOptions,
  displayMembershipCode,
} from '../../../assets/helpers/funciones';
import {
  OtpModal,
  RenewModal,
  CartModal,
} from '../../common/Modals/Modals.jsx';
import authService from '../../../services/authService.js';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner';
import { usersService } from '../../../services/usersService.js';
import { vehicleService } from '../../../services/vehicleService.js';
import { salesRoles } from '../../../assets/helpers/roles';
import { statesService } from '../../../services/statesService.js';
import { surchargesService } from '../../../services/surchargesService.js';
import { discountService } from '../../../services/discountService.js';
const itemsPerpage = [10, 25, 50, 100, 500];
const ACTIVE_DISCOUNT_RENEWAL_LANDING = 'Renewal';
export const RenewalDB = () => {
  const { t } = useTranslation();
  const tableRef = useRef(null);
  const history = useHistory();
  const user = authService.getUser();

  const { statusId } = useParams();

  const {
    register,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schemas.filterRenewalMembership(t)),
  });

  const {
    register: register2,
    formState: { errors: errors2 },
    reset: reset2,
    setValue: setValue2,
    watch: watch2,
    control: control2,
    handleSubmit: handleSubmit2,
    setError: setError2,
  } = useForm({
    resolver: yupResolver(schemas.autorenovationSearchSchema(t)),
  });

  const campaignOptions = {
    contact: 'Contactar',
    scheduled: 'Agendado',
    pendingPayment: 'Pago pendiente',
    firstStep: 'Cierre 1',
    secondStep: 'Cierre 2',
    thirdStep: 'Cierre 3',
    credit: 'Crédito',
    traveling: 'De viaje',
    noRenew: 'No va a renovar',
    damaged: 'Averiado',
    notApproved: 'revisión no aprobada',
    notScheduled: 'revisión no agendada',
    noContact: 'No contactar',
  };

  const membershipCodes = {
    GOLDF4: 'GOLDF4',
    PLUSF4: 'PLUSF4',
    GOLD: 'GOLD',
    PLUS: 'PLUS',
    CLASSIC: 'CLASSIC',
    RIDERY: 'RIDERY',
    MOTORIDER: 'MOTORIDER',
    RETRO: 'RETRO',
    RCV_ELITE: 'RCV_ELITE',
    RCV: 'RCV',
    F2: 'F2',
    GOLDM: 'GOLDM',
    BARATICO: 'BARATICO',
  };

  const surchargesAndDiscounts = {
    '-5%': '-5',
    '-10%': '-10',
    '-15%': '-15',
    '0%': '0',
    '+20%': '20',
    '+50%': '50',
  };

  const [statusOptions, setStatusOptions] = useState([]);
  const [statusSelected, setStatusSelected] = useState('');
  const [campaignAction, setCampaignAction] = useState('');
  const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
  const [discountCodeFilter, setDiscountCodeFilter] = useState([]);
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [statesOptions, setStatesOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [planOptions, setPlanOptions] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  // Identificador de la última petición de cálculo de precio. Evita que una
  // respuesta obsoleta (p. ej. el cálculo sin descuento) pise el priceInfo bueno.
  const priceReqId = useRef(0);
  const [rcvOptions, setRCVOptions] = useState([]);
  const [priceInfo, setPriceInfo] = useState('');
  const [isVehicleDriver, setIsVehicleDriver] = useState('SI');
  const [discountId, setDiscountId] = useState('');
  const [showRenewModal, setShowRenewModal] = useState({
    isOpen: false,
    selected: '',
  });
  const [showCartModal, setShowCartModal] = useState({
    isOpen: false,
    type: '',
  });
  const [vehicleFilerUsageOptions, setVehicleFilerUsageOptions] = useState([]);

  const [campaignActionOptions, setCampaignActionOptions] = useState([]);
  const [planSelectedOptions, setPlanSelectedOptions] = useState([]);
  const [channelOptions, setChannelOptions] = useState([]);
  const [membershipStatusOptions, setMembershipStatusOptions] = useState([]);
  const [advisorOptions, setAdvisorOptions] = useState([]);
  const [searchCategoryOption, setSearchCategoryOption] = useState('phone');
  const [membershipEndDate, setMembershipEndDate] = useState({});
  const [rcvEndDate, setRcvEndDate] = useState({});
  const [tableHeader, setTableHeader] = useState(renewalTableHeader);
  const [otpCode, setOtpCode] = useState('');
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [exportableType, setExportableType] = useState('');

  const [isLoadingEmail, setIsLoadingEmail] = useState(false);
  const [showExportBreadcrumb, setShowExportBreadcrumb] = useState(false);
  const [isVisible, setIsVisible] = useState(showExportBreadcrumb);

  useEffect(() => {
    if (showExportBreadcrumb) {
      setIsVisible(true);
    }
  }, [showExportBreadcrumb]);

  const handleAnimationEnd = () => {
    if (!showExportBreadcrumb) {
      setIsVisible(false);
    }
  };

  const [membershipsDatatable, setMembershipsDatatable] = useState({
    limit: itemsPerpage[2],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    dateFrom: '',
    dateTo: '',
    isLoading: true,
    searchParam: '',
  });
  const [advisors, setAdvisors] = useState([]);
  const [advisorsList, setAdvisorsList] = useState([]);
  const [channels, setChannels] = useState([]);

  const handleDateChange = () => {
    getMembershipsByStatus();
  };

  const campaignActionList = [
    { name: 'Contactar', _id: 'Contactar' },
    { name: 'Agendado', _id: 'Agendado' },
    {
      name: 'Pago pendiente',
      _id: 'Pago pendiente',
      checked: false,
    },
    { name: 'Cierre 1', _id: 'Cierre 1' },
    { name: 'Cierre 2', _id: 'Cierre 2' },
    { name: 'Cierre 3', _id: 'Cierre 3' },
    { name: 'Crédito', _id: 'Crédito' },
    { name: 'De viaje', _id: 'De viaje' },
    {
      name: 'No va a renovar',
      _id: 'No va a renovar',
      checked: false,
    },
    { name: 'Averiado', _id: 'Averiado' },
    {
      name: 'revisión no aprobada',
      _id: 'revisión no aprobada',
      checked: false,
    },
    {
      name: 'revisión no agendada',
      _id: 'revisión no agendada',
      checked: false,
    },
    {
      name: 'No contactar',
      _id: 'No contactar',
      checked: false,
    },
  ];

  const selectitemsPerpage = (event) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * membershipsDatatable?.limit,
      };
    });
  };

  const handleSearchChange = (event) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        searchParam: event?.target?.value,
        page: 1,
        offset: 0,
      };
    });
  };

  const exportTable = () => {
    setShowExportBreadcrumb(!showExportBreadcrumb);
  };

  const exportRenewTable = (type) => {
    let params = {
      contactInCampaign: campaignAction,
      status: statusSelected,
      dateFrom: getDateFormat(watch('sinceMonth'), watch('sinceYear'), '1'),
      dateTo: getDateFormat(watch('untilMonth'), watch('untilYear'), '31'),
      limit: membershipsDatatable?.limit,
      offset: membershipsDatatable?.offset,
      searchParam: membershipsDatatable?.searchParam,
      searchCategory: searchCategoryOption,
      byMail: true,
      email: authService?.getUser()?.email,
    };

    let body = {
      campaignAction: campaignActionOptions,
      discountPercent: discountCodeFilter.map(Number),
      statusList: membershipStatusOptions,
      plans: planSelectedOptions,
      channels: channelOptions,
      advisors: advisorOptions,
      membershipEndDate: membershipEndDate ? membershipEndDate : '',
      rcvEndDate: rcvEndDate ? rcvEndDate : '',
    };
    if (
      ![
        salesRoles?.SALES_ADMIN,
        salesRoles?.SALES_ADMIN_AUX,
        salesRoles?.SALES_DEVELOPER,
        salesRoles?.SALES_SUPERVISOR,
      ].includes(authService?.getUserType()) &&
      params.byMail === true
    ) {
      body.otp = otpCode;
    }

    if (!body.membershipEndDate.from || !body.membershipEndDate.until) {
      delete body.membershipEndDate;
    }
    if (!body.rcvEndDate.from || !body.rcvEndDate.until) {
      delete body.rcvEndDate;
    }

    if (body.statusList[0] === '') delete body.statusList;

    if (type && type !== '') {
      params.type = type;
    }

    if (!isLoadingEmail) {
      notify(
        `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
        'info'
      );
      setIsLoadingEmail(true);
      setOtpCode('');
      setShowOtpModal(false);

      membershipService
        .getMembershipsToBeRenewed(filterParams(params), body)
        .then((response) => {
          if (response.status === 200) {
            setIsLoadingEmail(false);
          } else {
            notify(`${response.message}` || 'error', 'error');
            setIsLoadingEmail(false);
            setOtpCode('');
          }
        })
        .catch((error) => {
          setIsLoadingEmail(false);
        });
    }
    setShowExportBreadcrumb(!showExportBreadcrumb);
  };

  const redirectToEditOrder = (orderId) => {
    history.push(`/afiliations/edit-order/${orderId}`);
  };

  const redirectToOrderDetail = (order) => {
    history.push(
      `/afiliations/order-details/${order?._id}/vehicle/${order?.vehicle?._id}`
    );
  };

  const actionOverMembership = (membership) => {
    getAvailableMemberships(membership);
  };

  const preloadOptions = async (currentYear) => {
    let years = [];

    for (let i = currentYear + 1; i > 2000; i--) {
      years.push({
        name: i.toString(),
        _id: i.toString(),
      });
    }
    setYearOptions(years);
  };

  const preloadDates = () => {
    let currentYear = new Date()?.getFullYear();
    let currenMonth = moment(new Date()).subtract(1, 'months').month();
    let untilMonth = moment(new Date()).add(2, 'months').month();
    let sinceYear = moment(new Date()).subtract(1, 'months').year();
    let untilYear = moment(new Date()).add(4, 'months').year();

    preloadOptions(currentYear).then((r) => {
      setTimeout(() => {
        setValue('sinceYear', sinceYear);
        setValue('untilYear', untilYear);
        setValue('sinceMonth', monthsOptions[currenMonth]?._id);
        setValue('untilMonth', monthsOptions[untilMonth]?._id);
        getMembershipsByStatus();
      }, 1000);
    });
  };

  useEffect(() => {
    preloadDates();
    getStatus();
    getAvailableAdvisors();
  }, []);

  useEffect(() => {
    getAvailableAdvisorsAndChannels();
  }, [
    watch('sinceMonth'),
    watch('sinceYear'),
    watch('untilMonth'),
    watch('untilYear'),
    membershipsDatatable?.searchParam,
    membershipsDatatable?.data,
    statusSelected,
    campaignActionOptions,
    planSelectedOptions,
    channelOptions,
    discountCodeFilter,
    advisorOptions,
    membershipStatusOptions,
    membershipEndDate,
    rcvEndDate,
  ]);

  useEffect(() => {
    getMembershipsByStatus();
    advisorListOptions();
    channelListOptions();
  }, [
    membershipsDatatable?.page,
    membershipsDatatable?.offset,
    membershipsDatatable?.limit,
    membershipsDatatable?.type,
    statusSelected,
    campaignActionOptions,
    planSelectedOptions,
    channelOptions,
    discountCodeFilter,
    advisorOptions,
    membershipStatusOptions,
    membershipEndDate,
    rcvEndDate,
  ]);

  const getDateFormat = (month, year, day) => {
    // if (month && year && day) {
    let date = new Date();
    if (month && year) {
      date = new Date(month + `${day},` + year);
      date = moment(date)?.format('MM-DD-YYYY');
    }
    return date;
    // } else return undefined;
  };

  const advisorListOptions = (arr) => {
    let advisors = [];
    arr?.sort((a, b) => {
      if (a?.fullName < b?.fullName) {
        return -1;
      }
      if (a?.fullName > b?.fullName) {
        return 1;
      }
      return 0;
    });

    if (arr) {
      for (let i = 0; i < arr?.length; i++) {
        advisors.push({
          _id: arr[i]?._id,
          name: capitalize(arr[i]?.fullName),
        });
      }
    }
    return advisors;
  };

  const channelListOptions = (arr) => {
    let channels = [];
    arr?.sort((a, b) => {
      if (a?.channel < b?.channel) {
        return -1;
      }
      if (a?.channel > b?.channel) {
        return 1;
      }
      return 0;
    });

    if (arr) {
      for (let i = 0; i < arr?.length; i++) {
        channels.push({
          _id: arr[i]?._id,
          name: capitalize(arr[i]?.channel),
        });
      }
    }
    return channels;
  };

  const handleCampaignActionOptions = (arr) => {
    setCampaignActionOptions(arr);
  };

  const filterMembershipCodes = (obj) => {
    let codes = [];
    for (let key in obj) {
      codes.push({
        _id: obj[key],
        name: key,
      });
    }
    return codes;
  };

  const filterDiscountsAndSurcharges = (obj) => {
    let discounts = [];
    for (let key in obj) {
      discounts.push({
        _id: obj[key],
        name: key,
      });
    }
    return discounts;
  };

  const handleChannelOptions = (arr) => {
    setChannelOptions(arr);
  };

  const handleMembershipEndDate = (from, until) => {
    if (from && until) {
      setMembershipEndDate({
        from: from,
        until: until,
      });
    }
  };

  const handleDiscountCodeFilter = (arr) => {
    // arr = arr.map(Number);
    setDiscountCodeFilter(arr);
  };

  const handleRcvEndDate = (from, until) => {
    if (from && until) {
      setRcvEndDate({
        from: from,
        until: until,
      });
    }
  };

  const handlePlansOptions = (arr) => {
    setPlanSelectedOptions(arr);
  };

  const handleMembershipStatusOptions = (arr) => {
    setMembershipStatusOptions(arr);
  };

  const handleAdvisorOptions = (arr) => {
    setAdvisorOptions(arr);
  };

  const getMembershipsByStatus = () => {
    if (
      watch('sinceMonth') &&
      watch('sinceYear') &&
      watch('untilMonth') &&
      watch('untilYear')
    ) {
      setMembershipsDatatable((prevState) => {
        return {
          ...prevState,
          isLoading: true,
        };
      });

      let params = {
        contactInCampaign: campaignAction,
        status: statusSelected,
        dateFrom: getDateFormat(watch('sinceMonth'), watch('sinceYear'), '1'),
        dateTo: getDateFormat(watch('untilMonth'), watch('untilYear'), '31'),
        limit: membershipsDatatable?.limit,
        offset: membershipsDatatable?.offset,
        searchParam: membershipsDatatable?.searchParam,
        searchCategory: searchCategoryOption,
      };

      let body = {
        campaignAction: campaignActionOptions,
        statusList: membershipStatusOptions,
        plans: planSelectedOptions,
        discountPercent: discountCodeFilter.map(Number),
        channels: channelOptions,
        advisors: advisorOptions,
        membershipEndDate: membershipEndDate ? membershipEndDate : '',
        rcvEndDate: rcvEndDate ? rcvEndDate : '',
      };

      if (!body.membershipEndDate.from || !body.membershipEndDate.until) {
        delete body.membershipEndDate;
      }
      if (!body.rcvEndDate.from || !body.rcvEndDate.until) {
        delete body.rcvEndDate;
      }

      if (body.statusList[0] === '') delete body.statusList;

      membershipService
        .getMembershipsCountRenewal(filterParams(params), body)
        .then((response) => {
          if (response.status === 200) {
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                count: response?.data?.total,
              };
            });
          } else {
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch(() => {});

      setIsloading(true);
      membershipService
        .getMembershipsToBeRenewed(filterParams(params), body)
        .then((response) => {
          if (response.status === 200) {
            setMembershipsDatatable((prevState) => {
              setIsloading(false);
              return {
                ...prevState,
                data: response?.data?.memberships,
                isLoading: false,
              };
            });
          } else {
            notify(`${response.message}` || 'error', 'error');
            setMembershipsDatatable((prevState) => {
              setIsloading(false);
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }
        })
        .catch((error) => {
          setMembershipsDatatable((prevState) => {
            setIsloading(false);
            return {
              ...prevState,
              isLoading: false,
            };
          });
        });
      return true;
    }
  };

  const getStatus = () => {
    membershipService
      .getStatuses()
      .then((response) => {
        if (response.status === 200) {
          let data = [];
          for (let i = 0; i < response?.data.length; i++) {
            data.push({
              _id: response?.data[i]?._id,
              name: capitalize(response?.data[i]?.name),
              realName: response?.data[i]?.name,
            });

            if (response?.data[i]?._id === statusId) {
              setStatusSelected(response?.data[i]?._id);
            }
          }

          data = data?.filter((d) =>
            [
              // planStatus?.PENDING_FOR_APPROBAL,
              planStatus?.TO_BE_RENEW,
              planStatus?.EXPIRED,
              planStatus?.TO_BE_EXPIRED,
            ].includes(d?.realName)
          );
          setStatusOptions([{ name: 'Todos', _id: '' }, ...data]);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
    return true;
  };

  const applyDiscount = (memId) => {
    return surchargesService
      .discountSurchargeAppliesToMembership({ memId })
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          // ? aqui colocar el set para mostrar el checkbox
          if (!response.data.appliesConfig) {
            return true;
          } else if (
            response.data.appliesConfig &&
            response.data.useRenewDiscount
          ) {
            notify(
              'Aplica descuento de renovación debido a una configuración de parámetros',
              'info'
            );
            return true;
          } else if (
            response.data.appliesConfig &&
            !response.data.useRenewDiscount
          ) {
            notify(
              'No aplica descuento de renovación debido a una configuración de parámetros',
              'info'
            );
            return false;
          }
        } else {
          return false;
        }
      })
      .catch((error) => {
        notify(`No se pudo validar el código de descuento`, 'error');
        console.log(`No se pudo validar el código de descuento`, error);
        return false;
      });
  };

  const shouldApplyActiveRenewalDiscount = (membership) => {
    const accidentRate = (membership?.accidentRate || '').toUpperCase();
    return ['ORO', 'PLATA'].includes(accidentRate);
  };

  const tryApplyActiveRenewalDiscount = async (
    membership,
    selectedPlanOptions,
    selectedPlanId
  ) => {
    if (!shouldApplyActiveRenewalDiscount(membership)) {
      return false;
    }

    if (!selectedPlanId) {
      return false;
    }

    try {
      const activeDiscountResponse = await discountService.getActiveDiscount(
        filterParams({ landing: ACTIVE_DISCOUNT_RENEWAL_LANDING })
      );

      if (activeDiscountResponse?.status !== 200) {
        return false;
      }

      const discountCode = activeDiscountResponse?.data?.discountCode?.code;

      if (!discountCode) {
        return false;
      }

      const validateParams = {
        code: discountCode,
        type: validateCodeEnum?.RENEWAL,
      };

      const validateDiscountResponse = await giftCardService.validateDiscount(
        'discountCodes',
        filterParams(validateParams)
      );

      if (![200, 201].includes(validateDiscountResponse?.status)) {
        return false;
      }

      const nextDiscountId = validateDiscountResponse?.data?._id;

      if (!nextDiscountId) {
        return false;
      }

      setValue2('codeType', codeTypeEnum?.DISCOUNT);
      setValue2('codigo', discountCode.toUpperCase());
      setDiscountId(nextDiscountId);
      await calculateRenewalPrice(membership, selectedPlanOptions, nextDiscountId, {
        code: selectedPlanId,
        codeType: codeTypeEnum?.DISCOUNT,
        rcv: 'ninguno',
      });

      return true;
    } catch (error) {
      console.log('RenewalDB: tryApplyActiveRenewalDiscount', error);
      return false;
    }
  };

  const handleRenewModal = async (membership, planOptions) => {
    if (!membership) {
      setRCVOptions([]);
      setPlanOptions([]);
      // setValue2("rcv", "")
      // setValue2("code", "")
      reset2();
      setPriceInfo('');
    }
    filterVehicleUse(membership);

    setShowRenewModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showRenewModal?.isOpen,
        selected: membership ? membership : '',
      };
    });

    if (membership) {
      const applyDiscountCheck = await applyDiscount(membership?._id);
      const [option] = planOptions?.filter(
        (p) => p?.name === membership?.membershipCode
      );
      const selectedPlanId = option?._id;

      setValue2('code', selectedPlanId);
      setValue2(
        'useDiscount',
        applyDiscountCheck &&
          !(
            user?.roles?.[0]?.code === salesRoles.SALES_COUNTER &&
            user?.type === 'Externo'
          )
      );
      // Conserva los km heredados de la membresía actual (ej. 300); si no,
      // se usa la cobertura base vigente del plan (Gold = 400 km).
      const initialKm = getDefaultPlanKm('GOLD', membership?.km);
      if (membership?.membershipCode === 'GOLD') {
        setValue2('km', initialKm);
      }
      await getRCVs(membership, planOptions, selectedPlanId);
      if (membership?.membershipCode === 'GOLD') {
        setValue2('km', initialKm);
      }
      await tryApplyActiveRenewalDiscount(
        membership,
        planOptions,
        selectedPlanId
      );
    }
  };

  const getAvailableMemberships = (membership) => {
    let params = {
      year: membership?.vehicle?.year,
      class: membership?.vehicle?.class,
      landing: LANDING?.SELF_RENEWAL,
    };

    membershipCatalogService
      .getAvailableMemberships(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          let data = [];

          for (let i = 0; i < response?.data.length; i++) {
            data?.push({
              name: displayMembershipCode(response?.data[i]?.code),
              _id: response?.data[i]?._id,
            });
          }
          setPlanOptions(data);
          handleRenewModal(membership, data);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const getRCVs = (membership, planOptions, selectedPlanId) => {
    const currentPlanId = selectedPlanId || watch2('code');

    if (currentPlanId) {
      const [selectedOption] = planOptions?.filter(
        (p) => p?._id === currentPlanId
      );

      if (
        [membershipCodes?.GOLD, membershipCodes?.GOLDM]?.includes(
          selectedOption?.name
        )
      ) {
        if (!watch2('km')) {
          setValue2(
            'km',
            getDefaultPlanKm(selectedOption?.name, showRenewModal?.selected?.km)
          );
        }
      } else {
        setValue2('km', '');
      }

      return productService
        .getRCVs({ membership: currentPlanId })
        .then((response) => {
          if (response.status === 200) {
            let data = [{ _id: 'ninguno', name: 'N/A' }, ...response?.data];

            data = filterRCVOptions(data);

            setRCVOptions(data);
            setValue2('rcv', 'ninguno');
            setValue2('codigo', '');
            setValue2('codeType', '');
            setDiscountId('');

            if (showRenewModal?.selected?._id || membership) {
              return calculateRenewalPrice(membership, planOptions, '', {
                code: currentPlanId,
                rcv: 'ninguno',
              });
            }
          } else {
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch(() => {});
    }

    return Promise.resolve();
  };

  const calculateRenewalPrice = async (
    membership,
    planOptions,
    discountId,
    forcedValues = {}
  ) => {
    const currentCode = forcedValues?.code || watch2('code');
    const currentCodeType = forcedValues?.codeType || watch2('codeType');
    const currentRcv = forcedValues?.rcv || watch2('rcv');

    const params = {
      rcv: currentRcv === 'ninguno' ? '' : currentRcv,
      code: currentCode,
      giftcard: currentCodeType === codeTypeEnum?.GIFTCARD ? discountId : '',
      vehicleUsage: !['ninguno', rcvEnum?.NA].includes(currentRcv)
        ? watch2('vehicleUsage')
        : '',
      discountCode:
        currentCodeType === codeTypeEnum?.DISCOUNT ? discountId : '',
      useExtendedTow: watch2('hasExtendedTow')
        ? watch2('hasExtendedTow')
        : false,
      useRenewalDiscount: watch2('useDiscount') ? watch2('useDiscount') : false,
      hasRcvCard:
        watch2('hasRcvCard') && watch2('rcv') !== 'ninguno'
          ? watch2('hasRcvCard')
          : false,
    };

    if (currentRcv === 'ninguno') {
      setValue2('hasRcvCard', false);
    }

    const [selectedOption] = planOptions?.filter((p) => p?._id === currentCode);

    if (
      [membershipCodes?.GOLD, membershipCodes?.GOLDM]?.includes(
        selectedOption?.name
      )
    ) {
      if (!watch2('km')) {
        const defaultKm = getDefaultPlanKm(
          selectedOption?.name,
          showRenewModal?.selected?.km
        );
        setValue2('km', defaultKm);
        params.km = defaultKm;
      } else {
        params.km = watch2('km');
      }
    }

    // Cada llamada obtiene un id incremental. Solo la respuesta cuyo id siga
    // siendo el último vigente puede escribir el estado: así, si varias llamadas
    // se solapan (al abrir el modal con recargo + descuento), la respuesta que
    // gana es siempre la más reciente y no una obsoleta.
    const reqId = ++priceReqId.current;
    const isLatest = () => reqId === priceReqId.current;

    setIsloading(true);
    try {
      const response = await membershipService.calculateRenewalPrice(
        filterParams(params),
        showRenewModal?.selected?._id || membership?._id
      );

      if (!isLatest()) return; // llegó una petición más nueva: descartamos esta

      if (response.message === 'Success') {
        if (response.status === 200) {
          setPriceInfo(response?.data);
        }
        return;
      }
      if (
        response.status === 400 &&
        [
          'discountCode contains an invalid value',
          'giftcard contains an invalid value',
        ]?.includes(response?.message)
      ) {
        notify(`Codigo Invalido`, 'info');
      } else {
        notify(`${response.message}`, 'error');
      }
    } catch (error) {
      console.log('RenewalDB: calculateRenewalPrice', error);
    } finally {
      if (isLatest()) setIsloading(false);
    }
  };

  const clearRCVForm = () => {
    setValue2('rcvHolderFirstName', '');
    setValue2('rcvHolderLastName', '');
    setValue2('rcvHolderIdentificationType', '');
    setValue2('rcvHolderIdentification', '');
    setValue2('rcvHolderState', '');
    setValue2('rcvHolderCity', '');
    setValue2('rcvHolderPhonePrefix', '');
    setValue2('rcvHolderPhoneNumber', '');
    setValue2('rcvHolderAddress', '');
  };

  const handleRCVHolder = (e) => {
    if (e?.target?.value === 'SI') {
      setValue2('isVehicleDriver', true);
      setIsVehicleDriver(e?.target?.value);
      clearRCVForm();
    }
    if (e?.target?.value === 'NO') {
      setValue2('isVehicleDriver', false);
      setIsVehicleDriver(e?.target?.value);
      clearRCVForm();
    }
  };

  const handleDiscountCode = () => {
    removeBlankSpacesAndUppercase(watch2('codigo'), 'codigo', setValue2);

    if (watch2('codigo').length >= 6 && watch2('code')) {
      validateCode();
    }

    // if (watch2('codigo').trim().length > 6) {
    // notify('Ingrese un código válido', 'info');
    // setValue2('codigo', watch2('codigo').slice(0, 6));
    // }
  };

  const validateCode = () => {
    let discountType = '';

    if (watch2('codeType') === codeTypeEnum?.DISCOUNT) {
      discountType = 'discountCodes';
    }
    if (watch2('codeType') === codeTypeEnum?.GIFTCARD) {
      discountType = 'giftcards';
    }

    let params = {
      code: watch2('codigo'),
      type:
        watch2('codeType') === codeTypeEnum?.DISCOUNT
          ? validateCodeEnum?.RENEWAL
          : '',
    };

    if (params?.code) {
      giftCardService
        .validateDiscount(discountType, filterParams(params))
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            setDiscountId(response?.data?._id);
            calculateRenewalPrice('', planOptions, response?.data?._id);
          } else {
            if ([404].includes(response.status)) {
              notify(`Codigo no encontrado o expirado`, 'info');
              return null;
            }

            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => {});
    }
  };

  const selfRenew = handleSubmit2(async (data) => {
    let params = {
      code: watch2('code'),
      rcvProduct: watch2('rcv') === 'ninguno' ? '' : watch2('rcv'),
      discountCodeId:
        watch2('codeType') === codeTypeEnum?.DISCOUNT ? discountId : '',
      giftcardId:
        watch2('codeType') === codeTypeEnum?.GIFTCARD ? discountId : '',
      km: watch2('km') ? watch2('km') : '',
      vehicleUsage: !['ninguno', rcvEnum?.NA].includes(watch2('rcv'))
        ? watch2('vehicleUsage')
        : '',
      useExtendedTow: watch2('hasExtendedTow')
        ? watch2('hasExtendedTow')
        : false,
      useRenewalDiscount: watch2('useDiscount') ? watch2('useDiscount') : false,
      saleChannel: showRenewModal?.selected?.saleChannelId,
      rcvHolder: {
        isVehicleDriver: isVehicleDriver === 'SI' ? true : false,
        firstName: watch2('rcvHolderFirstName'),
        lastName: watch2('rcvHolderLastName'),
        fullName: `${watch2('rcvHolderFirstName')} ${watch2(
          'rcvHolderLastName'
        )}`,
        identification: watch2('rcvHolderIdentification'),
        identificationType: watch2('rcvHolderIdentificationType'),
        phonePrefix: watch2('rcvHolderPhonePrefix'),
        phoneNumber: watch2('rcvHolderPhoneNumber'),
        state: watch2('rcvHolderState'),
        city: watch2('rcvHolderCity'),
        address: watch2('rcvHolderAddress'),
      },
      ...(watch2('hasRcvCard') ? { hasRcvCard: watch2('hasRcvCard') } : {}),
    };

    if (
      watch2('rcv') &&
      watch2('rcv') !== 'ninguno' &&
      !watch2('vehicleUsage')
    ) {
      setError2(`vehicleUsage`, {
        type: 'custom',
        message: 'Obligatorio',
      });
      return;
    }

    params.rcvHolder = clearObject(params.rcvHolder);
    if (
      params.rcvHolder.firstName === '' ||
      params.rcvHolder.firstName === undefined ||
      params.rcvHolder.lastName === '' ||
      params.rcvHolder.lastName === undefined
    ) {
      delete params.rcvHolder.fullName;
    }

    if (!isLoading) {
      setIsloading(true);
      membershipService
        .selfRenew(filterParams(params), showRenewModal?.selected?._id)
        .then((response) => {
          if ([200, 201]?.includes(response.status)) {
            if (response?.message) {
              notify(`${response.message}`, 'info');
            }
            history.push(`/afiliations/edit-order/${response?.data?._id}`);
          } else {
            setIsloading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => {});
    }
  });

  const updateMembershipFromGrid = (data) => {
    const body = {};
    if (data?.observation) {
      body.observation = data?.observation;
    }
    if (data?.campaignAction) {
      body.campaignAction = data?.campaignAction;
    }
    if (data?.assignedAdvisor || data?.assignedAdvisor === null) {
      body.assignedAdvisor = data?.assignedAdvisor;
    }
    if (data?.situation) {
      body.situation = data?.situation;
    }

    if (
      body?.observation ||
      body?.campaignAction ||
      body?.assignedAdvisor ||
      body?.assignedAdvisor === null ||
      body?.situation ||
      body?.seller
    ) {
      membershipService
        .updateFromGrid(data?.id, body)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify('Actualización exitosa', 'info');
          } else {
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => {
          notify('Error al actualizar', 'error');
        });
    }
  };

  const getAvailableAdvisors = () => {
    usersService
      .getSalesUsers({
        status: 'Activo',
        module: 'Ventas',
      })
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.length === 0) {
            notify('No hay asesores disponibles', 'info');
          }
          setAdvisorsList(response?.data.users);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => {
        notify('Error al consultar asesores', 'error');
      });
  };

  const getAvailableAdvisorsAndChannels = () => {
    let params = {
      dateFrom: getDateFormat(watch('sinceMonth'), watch('sinceYear'), '1'),
      dateTo: getDateFormat(watch('untilMonth'), watch('untilYear'), '31'),
      limit: membershipsDatatable?.limit,
      offset: membershipsDatatable?.offset,
      searchParam: membershipsDatatable?.searchParam,
      searchCategory: searchCategoryOption,
    };

    let body = {
      campaignAction: campaignActionOptions,
      statusList: membershipStatusOptions,
      plans: planSelectedOptions,
      discountPercent: discountCodeFilter.map(Number),
      channels: channelOptions,
      advisors: advisorOptions,
      membershipEndDate: membershipEndDate ? membershipEndDate : '',
      rcvEndDate: rcvEndDate ? rcvEndDate : '',
    };

    if (!body.membershipEndDate.from || !body.membershipEndDate.until) {
      delete body.membershipEndDate;
    }
    if (!body.rcvEndDate.from || !body.rcvEndDate.until) {
      delete body.rcvEndDate;
    }

    if (body.statusList[0] === '') delete body.statusList;

    membershipService
      .renewFilterOptions(filterParams(params), body)
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.length === 0) {
            notify('No hay asesores disponibles', 'info');
          }
          setAdvisors(response?.data.advisors);
          setChannels(response?.data.channels);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => {
        notify('Error al consultar asesores', 'error');
      });
  };

  const handleCodeChange = () => {
    setValue2('codigo', '');
    setDiscountId('');
    calculateRenewalPrice('', planOptions, '');
  };

  const handleDiscountPercentage = () => {
    setValue2('useDiscount', watch2('useDiscount'));
    calculateRenewalPrice('', planOptions, discountId);
  };

  const clearFilters = () => {
    reset2();
    setCampaignActionOptions([]);
    setPlanSelectedOptions([]);
    setChannelOptions([]);
    setAdvisorOptions([]);
    setMembershipStatusOptions([]);
    setMembershipEndDate({});
    setRcvEndDate({});
    setDiscountCodeFilter([]);
  };

  const handleHeaderFilters = () => {
    renewalTableHeader.forEach((header) => {
      if (header.name === 'Asesor Asignado') {
        header.filterOptions = advisorListOptions(advisors);
        header.filterSearch = handleAdvisorOptions;
        header.sortable = true;
      } else if (header.name === 'Acción de Campaña') {
        header.filterOptions = campaignActionList;
        header.filterSearch = handleCampaignActionOptions;
        header.sortable = true;
      }
      // else if (header.name === 'Condición Afiliación') {
      //   header.filterOptions = statusOptions;
      //   header.filterSearch = handleMembershipStatusOptions;
      //   header.sortable = true;
      // }
      else if (header.name === 'Canal') {
        header.filterOptions = channelListOptions(channels);
        header.filterSearch = handleChannelOptions;
        header.sortable = true;
      } else if (header.name === 'Plan') {
        header.filterOptions = filterMembershipCodes(membershipCodes);
        header.filterSearch = handlePlansOptions;
        header.sortable = true;
      } else if (header.name === 'Fecha fin RCV') {
        header.filterSearch = handleRcvEndDate;
        header.sortable = true;
      } else if (header.name === 'Fecha fin plan') {
        header.filterSearch = handleMembershipEndDate;
        header.sortable = true;
      } else if (header.name === '% recarga/descuento') {
        header.filterOptions = filterDiscountsAndSurcharges(
          surchargesAndDiscounts
        );
        header.filterSearch = handleDiscountCodeFilter;
        header.sortable = true;
      } else {
        delete header.filterSearch;
      }
    });
    setTableHeader(renewalTableHeader);
  };

  const getSalesVehicleClasses = () => {
    vehicleService
      .getSalesVehicleClasses()
      .then((response) => {
        if (response.status === 200) {
          setVehicleClassesOptions(response?.data?.classes);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const getCities = (state) => {
    statesService
      .getCities(state ? state : watch('state'), true)
      .then((response) => {
        if (response.status === 200) {
          setCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
    return true;
  };

  const handleCity = (e) => {
    getCities(e.target.value);
  };

  const getStates = () => {
    statesService
      .getStates({ isActive: true })
      .then((response) => {
        if (response.status === 200) {
          let states = response?.data?.states;
          setStatesOptions(states);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const showOtp = (exportableName) => {
    setIsloading(true);
    setIsVisible(false);
    setExportableType(exportableName);
    if (!otpCode && !isLoading) {
      authService
        .sendOtp({ module: ExportableOtpModules.RENEWAL_MEMBERSHIPS })
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            notify('Ingrese el código OTP enviado a su correo', 'Success');
            setIsloading(false);
            setShowOtpModal(true);
          } else {
            setIsloading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => {
          setIsloading(false);
          console.log('error', error);
        });
    }
  };

  const handleCartModal = (membership, action) => {
    if (membership) {
      setShowCartModal((prevState) => {
        return {
          ...prevState,
          isOpen: true,
          type: action,
          membership: membership,
        };
      });
    } else {
      setShowCartModal((prevState) => {
        return {
          ...prevState,
          isOpen: false,
          type: '',
          membership: '',
        };
      });
    }
  };

  const addToCart = () => {
    membershipService
      .addToCart({ memToRenew: showCartModal?.membership?._id })
      .then((response) => {
        if (response.status === 200) {
          notify('Membresia agregada al carrito de renovaciones', 'success');
          handleCartModal();
          getMembershipsByStatus();
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
  };

  const removeFromCart = () => {
    membershipService
      .removeFromCart(showCartModal?.membership?._id)
      .then((response) => {
        if (response.status === 200) {
          notify('Membresia removida del carrito de renovaciones', 'success');
          handleCartModal();
          getMembershipsByStatus();
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
  };

  const filterAndSetUssage = (usageOptions, vehicleOptions, _class) => {
    if (usageOptions.includes(_class.name)) {
      const options = vehicleUsageOptions?.filter((option) =>
        vehicleOptions.includes(option?._id)
      );
      setVehicleFilerUsageOptions(options);
      if (options.length === 1) {
        setValue2('vehicleUsage', options[0]?._id);
      }
    }
  };

  const filterVehicleUse = (membership) => {
    const _class = filterById(
      vehicleClassesOptions,
      membership?.vehicle?.class
    );

    filterAndSetUssage(
      [vehiclesEnum?.AUTOMOVIL],
      [vehicleUsageEnum.PUBLIC, vehicleUsageEnum.PARTICULAR],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.RUSTICO],
      [
        vehicleUsageEnum.PUBLIC,
        vehicleUsageEnum.PARTICULAR,
        vehicleUsageEnum.LOAD,
      ],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.AUTOBUS, vehiclesEnum?.MINIBUS],
      [vehicleUsageEnum.PUBLIC],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.CAMIONETA],
      [
        vehicleUsageEnum.PUBLIC,
        vehicleUsageEnum.PARTICULAR,
        vehicleUsageEnum.LOAD,
      ],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.MOTO],
      [vehicleUsageEnum.LOAD, vehicleUsageEnum.PARTICULAR],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.TRIMOTO],
      [vehicleUsageEnum.LOAD],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.CAMION, vehiclesEnum?.AMBULANCIA, vehiclesEnum?.GRUA],
      [vehicleUsageEnum.LOAD],
      _class
    );
  };

  useEffect(() => {
    getSalesVehicleClasses();
    getStates();
    handleHeaderFilters();
  }, [
    advisors,
    campaignActionOptions,
    statusOptions,
    channelOptions,
    membershipStatusOptions,
    planSelectedOptions,
    discountCodeFilter,
  ]);

  return (
    <>
      <Header />
      <CartModal
        modal={showCartModal}
        action={{
          handleCartModal: handleCartModal,
          addToCart: addToCart,
          removeFromCart: removeFromCart,
        }}
      />
      <RenewModal
        modal={showRenewModal}
        control={control2}
        watch={watch2}
        register={register2}
        errors={errors2}
        close={actionOverMembership}
        handleCity={handleCity}
        options={{
          planOptions: planOptions,
          rcvOptions: rcvOptions,
          codeTypeOptions: codeTypeOptions,
          KMServiceOptions: getKmServiceOptions(showRenewModal?.selected?.km),
          citiesOptions,
          statesOptions,
          vehicleFilerUsageOptions: vehicleFilerUsageOptions,
        }}
        onChange={{
          getRCVs: getRCVs,
          handleCodeChange: handleCodeChange,
          handleDiscountCode: handleDiscountCode,
          calculateRenewalPrice: calculateRenewalPrice,
          handleDiscountPercentage: handleDiscountPercentage,
        }}
        isVehicleDriver={isVehicleDriver}
        handleRCVHolder={handleRCVHolder}
        priceInfo={priceInfo}
        action={selfRenew}
        setValue={setValue2}
        membershipId={showRenewModal?.selected?._id}
      />
      {showOtpModal && (
        <OtpModal
          show={showOtpModal}
          handleClose={() => {
            setShowOtpModal(false);
            setOtpCode('');
          }}
          code={otpCode}
          setCode={setOtpCode}
          handleExport={() => exportRenewTable(exportableType)}
        />
      )}
      <LoadSpinner show={isLoading} />
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">
            Módulo de Renovación {membershipsDatatable?.count}
          </h1>
          <div style={{ display: 'flex' }}>
            <ActionButton
              label={'Exportar'}
              action={() => {
                exportTable();
              }}
            />
            <ActionButton
              label={'Ver Carrito de Renovaciones'}
              action={() =>
                history.push(`/dashboard/afiliations/multiple-renewal/renewal`)
              }
            />
          </div>
          {isVisible && (
            <div
              className={`breadcrumb breadcrumb-export-container`}
              onAnimationEnd={handleAnimationEnd}
            >
              <RenewalExportTypeBreadcrumb
                action={
                  ![
                    salesRoles?.SALES_ADMIN,
                    salesRoles?.SALES_ADMIN_AUX,
                    salesRoles?.SALES_DEVELOPER,
                    salesRoles?.SALES_SUPERVISOR,
                  ].includes(authService?.getUserType())
                    ? showOtp
                    : exportRenewTable
                }
              />
            </div>
          )}
        </div>
        <div className="breadcrumb-container">
          <div></div>
          <div
            className="exportables-buttons-container"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
              }}
              className=""
            >
              <Input
                bootstrap={'col-12 col-md-1'}
                label={'Desde Mes'}
                type={'select'}
                name={'sinceMonth'}
                options={monthsOptions}
                register={register}
                placeholder={''}
                onChange={() => handleDateChange()}
                errors={errors?.sinceMonth?.message}
              />
              <Input
                bootstrap={'col-12 col-md-1'}
                label={'Desde Año'}
                type={'select'}
                name={'sinceYear'}
                options={yearOptions}
                register={register}
                placeholder={''}
                onChange={() => handleDateChange()}
                errors={errors?.sinceYear?.message}
              />{' '}
              <Input
                bootstrap={'col-12 col-md-1'}
                label={'Hasta Mes'}
                type={'select'}
                options={monthsOptions}
                name={'untilMonth'}
                register={register}
                placeholder={''}
                onChange={() => handleDateChange()}
                errors={errors?.untilMonth?.message}
              />
              <Input
                bootstrap={'col-12 col-md-1'}
                label={'Hasta Año'}
                type={'select'}
                options={yearOptions}
                name={'untilYear'}
                register={register}
                placeholder={''}
                onChange={() => handleDateChange()}
                errors={errors?.untilYear?.message}
              />
              <div className="col-12 col-md-2" style={{ marginTop: '-10px' }}>
                <SearchInputWithSelector
                  placeholder={'Teléfono, Nombre, Apellido, Cédula o Placa'}
                  label={'Buscar'}
                  searchAction={getMembershipsByStatus}
                  value={membershipsDatatable?.searchParam}
                  onChange={handleSearchChange}
                  options={[
                    { _id: 'phone', name: 'Celular' },
                    { _id: 'name', name: 'Nombre' },
                    { _id: 'orderNumber', name: 'Orden #' },
                    { _id: 'email', name: 'Email' },
                    { _id: 'plate', name: 'Placa' },
                    { _id: 'identification', name: 'Cédula' },
                  ]}
                  width="50px"
                  setCategory={setSearchCategoryOption}
                  category={searchCategoryOption}
                />
              </div>
            </div>
          </div>

          <div className="buttons-container">
            <div>
              <SelectPerPage
                label={'Registros por página'}
                options={itemsPerpage}
                value={membershipsDatatable?.limit}
                onChange={selectitemsPerpage}
              />
            </div>
            <div className="buttons-container">
              <ActionButton
                label={'Limpiar filtros'}
                action={() => clearFilters()}
              />
              {[
                salesRoles?.SALES_ADMIN,
                salesRoles?.SALES_SUPERVISOR,
              ]?.includes(authService?.getUserType()) && (
                <a
                  href="/config/update-history/?type=renew"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ActionButton label={'Historial de Renovacion'} />
                </a>
              )}
            </div>
          </div>
        </div>

        <RenewalMembershipTable
          header={tableHeader}
          watch={watch}
          advisors={advisorsList}
          data={membershipsDatatable}
          handlePageChange={handlePageChange}
          redirectToEditOrder={redirectToEditOrder}
          redirectToOrderDetail={redirectToOrderDetail}
          actionOverMembership={actionOverMembership}
          tableRef={tableRef}
          updateFromGrid={updateMembershipFromGrid}
          campaingActions={campaignOptions}
          situationOptions={membershipSituationOptions}
          renewalPrice={calculateRenewalPrice}
          handleCartModal={handleCartModal}
        />
      </div>
    </>
  );
};
